import type { CSSProperties } from 'react';
import type { Actor } from '@/lib/directory';
import styles from './avatar.module.css';

/**
 * An actor's initials in a hue-tinted chip. Presentational and server-safe, so
 * both server components (drilldown) and client components (board) share it.
 *
 * The native `title` (the actor's name) is the incidental hover fallback; pass
 * `title={false}` when a house `Tooltip` on an ancestor already names the
 * actor(s), so the two don't stack (tooltip.tsx states the rule).
 */
export function Avatar({
  actor,
  size = 24,
  title,
}: {
  actor: Actor;
  size?: number;
  title?: string | false;
}) {
  return (
    <span
      className={styles.avatar}
      data-kind={actor.kind}
      data-missing={actor.missing || undefined}
      title={title === false ? undefined : (title ?? actor.name)}
      style={
        { width: size, height: size, fontSize: size * 0.4, '--hue': actor.hue } as CSSProperties
      }
    >
      {actor.initials}
    </span>
  );
}
